export default __webpack_public_path__ + "static/media/messages.c0282872.svg";